//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WorkNav from "./componets/WorkNav";
import util from '@/lib/util';
import NoticeList from "../components/noticeList";

export default {
    name: "noticeSheet",
    components: {
        NoticeList,
        WorkNav,
    },
    data() {
        return {
            memberId: 0
        }
    },
    methods: {
        getMyMember() {
            const vm = this;
            this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.member = vm.$store.state.member.memberInfo;
                vm.memberId = vm.member.id;
            }).finally(() => {
                vm.$toast.clear();
            });
        }
    },
    created() {
        this.getMyMember()
    }
};
